import store from '../store'

// 重定向白名单
const whiteList = [
    'login', // 登陆页面
    'wantInvoice',//发票申请页面，用于公众号使用
    'wantEnrolls',//我的报名查看界面
    'wantScores'//积分查询页面
]

// 路由前置拦截器
export function beforeEach(to, from, next) {
    return new Promise(function (resolve, reject) {
        if (store.state.user.token) {
            if (whiteList.indexOf(to.name) > -1) {
                //return next()
                resolve();
            }
            if (to.name === 'login') {
                //next({ path: '/' })
                resolve("/");
            } else {
                if (!store.state.user.info.id) {
                  store.dispatch('user/GetInfo').then(res => { // 拉取用户信息
                    next()
                  }).catch((err) => {
                  })
                   resolve();
                } else {
                     //next()
                     resolve();
                }
            }
        } else {
            if (whiteList.indexOf(to.name) !== -1) {
                 //next()
                 resolve();
            } else {
                //next(`/login?redirect=${to.path}`)
                //NProgress.done()
                resolve(`/login?redirect=${to.path}`);
            }
        }
    })
}